// 環境判斷工具函數
export const isDockerVersion = (): boolean => {
  return process.env.REACT_APP_DEPLOYMENT_TYPE === 'docker';
};

export const isSubscriptionEnabled = (): boolean => {
  // Docker 版本不啟用訂閱系統
  return !isDockerVersion();
};
